import { render, staticRenderFns } from "./SendMoney.vue?vue&type=template&id=e1145a1e&scoped=true"
import script from "./SendMoney.vue?vue&type=script&lang=js"
export * from "./SendMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1145a1e",
  null
  
)

export default component.exports